import React from "react";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Truck, Trash2, Loader2 } from "lucide-react";

export const BulkActionBar = ({
  selectedCount,
  drivers,
  onDispatch,
  onDelete,
  onClear,
  loading
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="sticky top-16 lg:top-0 z-30 p-3 sm:p-4 bg-primary/10 backdrop-blur-sm rounded-lg border border-primary/20">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <span className="text-sm font-medium">
          {selectedCount} selected
        </span>
        <div className="flex flex-wrap gap-2 flex-1">
          <Select onValueChange={onDispatch} disabled={loading}>
            <SelectTrigger className="w-full sm:w-40" data-testid="bulk-dispatch-select">
              <Truck className="h-4 w-4 mr-2" />
              <SelectValue placeholder="Dispatch to..." />
            </SelectTrigger>
            <SelectContent>
              {drivers.map(driver => (
                <SelectItem key={driver.id} value={driver.id}>{driver.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button 
            variant="destructive" 
            size="sm"
            onClick={onDelete}
            disabled={loading}
            className="flex-1 sm:flex-none"
            data-testid="bulk-delete-btn"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4 mr-1" />}
            Delete
          </Button>
          <Button 
            variant="outline" 
            size="sm"
            onClick={onClear}
            className="flex-1 sm:flex-none"
            data-testid="clear-selection-btn"
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionBar;
